var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: "",
        visible: _vm.visible,
        size: "720px",
        "custom-class": "record-detail-drawer",
        "destroy-on-close": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "record-detail-header",
        },
        [
          _c("div", { staticClass: "header-left" }, [
            _c("div", { staticClass: "coupon-title" }, [
              _vm._v(_vm._s(_vm.formatValue("couponName"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "coupon-meta" },
              [
                _c("span", { staticClass: "meta-item" }, [
                  _vm._v("领取人："),
                  _c("strong", [_vm._v(_vm._s(_vm.formatValue("receiver")))]),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "meta-item" }, [
                  _vm._v("领取时间：" + _vm._s(_vm.formatValue("receiveTime"))),
                ]),
                _vm._v(" "),
                _c(
                  "el-tag",
                  {
                    staticClass: "status-tag",
                    attrs: { type: _vm.statusTagType, effect: "dark" },
                  },
                  [_vm._v(_vm._s(_vm.formatValue("statusDesc")))]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "header-right" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: { click: _vm.copyRowInfo },
                },
                [_vm._v("复制信息")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "mini",
                    disabled: !_vm.hasCoordinates,
                  },
                  on: { click: _vm.openInMap },
                },
                [_vm._v("打开地图")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "record-detail-body",
        },
        [
          _c("div", { staticClass: "summary-cards" }, [
            _c("div", { staticClass: "summary-card big" }, [
              _c("p", { staticClass: "label" }, [_vm._v("优惠券名称")]),
              _vm._v(" "),
              _c("p", { staticClass: "value single-line" }, [
                _vm._v(_vm._s(_vm.formatValue("couponName"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "summary-card" }, [
              _c("p", { staticClass: "label" }, [_vm._v("领取人")]),
              _vm._v(" "),
              _c("p", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.formatValue("receiver"))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "summary-card" },
              [
                _c("p", { staticClass: "label" }, [_vm._v("状态")]),
                _vm._v(" "),
                _c(
                  "el-tag",
                  { attrs: { type: _vm.statusTagType, effect: "dark" } },
                  [_vm._v(_vm._s(_vm.formatValue("statusDesc")))]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "detail-grid" }, [
            _c("div", { staticClass: "detail-column" }, [
              _c(
                "div",
                { staticClass: "detail-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _c("i", { staticClass: "el-icon-s-order" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("领用信息")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-descriptions",
                    { attrs: { column: 1, border: "" } },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "领取方式" } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formatValue("receiveWayDesc")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "领取时间" } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formatValue("receiveTime")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "券有效期" } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formatValidity) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "归属小程序" } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formatValue("miniProgram")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "券类型" } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formatValue("voucherTypeDesc")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "优惠金额" } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatAmount(_vm.detail.discountAmount)
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detail-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _c("i", { staticClass: "el-icon-user" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("实名信息")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-descriptions",
                    { attrs: { column: 1, border: "" } },
                    [
                      _c("el-descriptions-item", { attrs: { label: "姓名" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.detail.realName || "--") +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "手机号" } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.detail.mobile || "--") +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "证件号" } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.detail.idNumber || "--") +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-column" }, [
              _c(
                "div",
                { staticClass: "detail-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _c("i", { staticClass: "el-icon-location" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("定位信息")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-descriptions",
                    { attrs: { column: 1, border: "" } },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "定位地址" } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formatLocationAddress) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "匹配地区" } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.detail.matchedArea || "--") +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "经纬度" } },
                        [
                          _c(
                            "div",
                            { staticClass: "coord-row" },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formatCoordinateString)),
                              ]),
                              _vm._v(" "),
                              _vm.hasCoordinates
                                ? _c("el-button", {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-document-copy",
                                      size: "mini",
                                      title: "复制经纬度",
                                    },
                                    on: { click: _vm.copyCoordinates },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasCoordinates
                                ? _c("el-button", {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-location-information",
                                      size: "mini",
                                      title: "在地图中打开",
                                    },
                                    on: { click: _vm.openInMap },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasCoordinates
                    ? _c("div", { staticClass: "map-hint" }, [
                        _vm._v(
                          "提示：可在新窗口打开地图或复制坐标到第三方工具查看。"
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }